module.exports = __webpack_public_path__ + "static/media/onedrive.986635ed.svg";